export default "__VITE_ASSET__BW57vBBv__"